import ExamInfoBar from './ExamInfoBar.js';
import { connect } from 'react-redux';
import {
    setValues,
    setInitialValues,
} from '../../../common/redux/ExamAnalysis/actions.js';
import { post, get, getCachedUserInfo } from '../../../common/utils';
const moment = require('moment');


const getExamDetailData = (dispatch, getState) => {
    return (_id) => {
        const url = process.env.REACT_APP_CEMENT_SERVER_PATH + (process.env.REACT_APP_PROJECT_TAG === "shifeng" ? 'api/exams/get_ongoing_one' : `api/exams/get_one?_id=${_id}`);
        dispatch(setValues({
            loading: true,
        }));
        return get(url, {})
            .then(retData => {
                dispatch(setValues({
                    loading: false,
                }));
                // console.log('getExamDetailData', retData);
                const userInfo = getCachedUserInfo();
                // 是否需要根据userInfo判断当前登陆状态，不登陆能看竞赛吗？
                if (!!retData.data && retData.data.errcode === 0) {
                    if (!!retData.data.result) {
                        const examDetail = retData.data.result;
                        let selectedUserValue = null;
                        // 默认选择当前用户第一个出现的数据
                        // 如果没有当前用户，选择第一个系统第一个用户
                        if (!!userInfo) {
                            const { user_id } = userInfo;
                            selectedUserValue = examDetail
                                .results
                                .reduce((pV, { user_values }, cIndex) => {
                                    if (pV !== null) return pV;
                                    const cUserIndex = user_values
                                        .reduce((pUV, { user_id: userId }, cUIndex) => {
                                            if (pUV !== null) return pUV;
                                            if (userId === user_id) return cUIndex;
                                            // console.log(cIndex, cUIndex);
                                            return pUV;
                                        }, null);
                                    if (cUserIndex !== null) return [cIndex, cUserIndex];
                                    return pV;
                                }, null);
                        };
                        if (selectedUserValue === null) {
                            //如果没有当前用户，选择第一个系统第一个用户
                            if (examDetail.results.length > 0) {
                                if (examDetail.results[0].user_values.length > 0) {
                                    selectedUserValue = [0, 0];
                                };
                            };
                        };
                        // console.log("selectUserValue", selectedUserValue);
                        // 应当先重置页面信息...
                        dispatch(setValues({
                            examDetail,
                            selectedUserValue,
                            examDetailUniqueId: Symbol(),
                        }));
                        return true;
                    } else {
                        //result === null,认为无竞赛
                        dispatch(setValues({ examDetail: null }));
                        return false;
                    };
                } else {
                    return false;
                };
            });

    };
};

const mapStateToProps = state => {
    const { examAnalysis } = state;
    const { } = examAnalysis;
    return {
        ...examAnalysis,
    };
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getExamDetailData: dispatch(getExamDetailData),
    };
}

const WrapperedExamInfoBar = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ExamInfoBar);

export default WrapperedExamInfoBar;